import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusItem } from '../components/BonusItem';
import { FAQItem } from '../components/FAQItem';
import { CheckIcon, ShieldCheckIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
const PIXEL_ID = '1206725874775777';
const fbTrack = (...args: any[]) => {
  try {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq(...args);
    }
  } catch (e) {
    // Pixel not available
  }
};
export function LandingPage() {
  useEffect(() => {
    try {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];if(s&&s.parentNode){s.parentNode.insertBefore(t,s)}
        else{b.head.appendChild(t)}}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
        fbq('init','${PIXEL_ID}');
        fbq('track','PageView');
      `;
      document.head.appendChild(script);
    } catch (e) {
      // Pixel initialization failed - will work in production
    }
  }, []);
  const handleBuyClick = () => {
    fbTrack('track', 'AddToCart', {
      content_name: 'The Prime Architect 40+',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
    window.location.href = 'https://www.flujovital360.com/cart/45985023361220:1';
  };
  const scrollToCTA = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full bg-black text-white" data-id="element-31">
      <UrgencyBar data-id="element-32" />

      {/* Hero Section */}
      <section className="pt-52 md:pt-32 pb-16 px-4 bg-gradient-to-b from-zinc-950 to-black" data-id="element-33">
        <div className="max-w-7xl mx-auto" data-id="element-34">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-35">
            <div className="space-y-8" data-id="element-36">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight" data-id="element-37">
                Cómo Reclamar el Vigor y el Cuerpo de tus{' '}
                <span className="text-gradient" data-id="element-38">20s en solo 90 Días</span>
              </h1>

              <p className="text-xl md:text-2xl text-gray-300 font-semibold" data-id="element-39">
                Sin Terapias Médicas Innecesarias, Sin 'Dietas de Hambre' y
                Entrenando solo 35 Minutos...
              </p>

              <p className="text-lg text-gray-400 leading-relaxed" data-id="element-40">
                — Incluso Si Sientes Que Tu Metabolismo Se Ha Detenido Por
                Completo.
              </p>

              <div className="bg-zinc-900 border-l-4 border-cyan-500 p-6 rounded-r-lg" data-id="element-41">
                <p className="text-gray-300 italic" data-id="element-42">
                  "El Protocolo de Arquitectura Hormonal diseñado
                  específicamente para hombres de 40+ que están cansados de
                  sentirse fatigados, con sobrepeso y 'fuera de juego' en su
                  propia vida."
                </p>
              </div>

              <CTAButton size="large" className="w-full md:w-auto" onClick={scrollToCTA} data-id="element-43">
                ACCESO INMEDIATO AL PLAN
              </CTAButton>
            </div>

            <div className="relative" data-id="element-44">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-3xl" data-id="element-45"></div>
              <img src="https://cdn.magicpatterns.com/uploads/31rQyWbxgqhoYaZSyBprF1/Imagen_2.png" alt="The Prime Architect 40+ - Producto digital con libro, tablet y smartphone mostrando el sistema" className="relative z-10 w-full rounded-lg shadow-2xl" data-id="element-46" />
            </div>
          </div>
        </div>
      </section>

      {/* Hook Section */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-47">
        <div className="max-w-4xl mx-auto" data-id="element-48">
          <div className="bg-zinc-900 border border-cyan-500/30 rounded-xl p-8 md:p-12" data-id="element-49">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-50">
              ¿Alguna vez te has mirado al espejo y te has preguntado...
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed text-center mb-6" data-id="element-51">
              ¿A dónde se fue ese hombre lleno de energía y confianza que solías
              ser?
            </p>
            <p className="text-gray-400 leading-relaxed" data-id="element-52">
              No eres el único. En los últimos 10 años, los niveles de
              testosterona en hombres americanos han caído a mínimos históricos,
              y la industria del "bienestar" quiere que creas que la única
              solución es inyectarte hormonas de por vida o resignarte a la
              'barriga de papá'.
            </p>
            <p className="text-cyan-400 font-bold text-xl mt-6 text-center" data-id="element-53">
              Pero hay un camino diferente.
            </p>
          </div>
        </div>
      </section>

      {/* Pain Agitation Section */}
      <section className="py-16 px-4 bg-black" data-id="element-54">
        <div className="max-w-6xl mx-auto" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-56">
            Trabajas duro. Eres el proveedor. Eres el líder.
            <br data-id="element-57" />
            <span className="text-red-500" data-id="element-58">
              Pero por dentro, sientes que el motor se está apagando.
            </span>
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-59">
            <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 space-y-4" data-id="element-60">
              <div className="flex items-start gap-3" data-id="element-61">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-62"></div>
                <p className="text-gray-300" data-id="element-63">
                  Llegas a las 3 PM y el{' '}
                  <strong className="text-white" data-id="element-64">"brain fog"</strong> (niebla
                  mental) te impide enfocarte en esa reunión crucial.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-65">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-66"></div>
                <p className="text-gray-300" data-id="element-67">
                  Llegas a casa y{' '}
                  <strong className="text-white" data-id="element-68">no tienes energía</strong> para
                  jugar con tus hijos, y mucho menos para conectar con tu
                  esposa.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-69">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-70"></div>
                <p className="text-gray-300" data-id="element-71">
                  Ves cómo tu{' '}
                  <strong className="text-white" data-id="element-72">abdomen se expande</strong> a
                  pesar de que "comes sano".
                </p>
              </div>
            </div>

            <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 space-y-4" data-id="element-73">
              <div className="flex items-start gap-3" data-id="element-74">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-75"></div>
                <p className="text-gray-300" data-id="element-76">
                  Sientes tus{' '}
                  <strong className="text-white" data-id="element-77">articulaciones rígidas</strong>{' '}
                  al despertar.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-78">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-79"></div>
                <p className="text-gray-300" data-id="element-80">
                  Y lo peor de todo: ese{' '}
                  <strong className="text-white" data-id="element-81">sutil miedo</strong> de que tus
                  mejores años hayan quedado atrás.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-red-900/20 to-orange-900/20 border border-red-500/30 rounded-xl p-8 text-center" data-id="element-82">
            <p className="text-xl text-gray-300 mb-4" data-id="element-83">
              Te han vendido la idea de que{' '}
              <strong className="text-white" data-id="element-84">"es solo la edad"</strong>, pero la
              ciencia moderna nos dice que es un fallo en tu arquitectura
              biológica.
            </p>
            <p className="text-2xl font-bold text-red-400" data-id="element-85">
              Estás operando con un software de 45 años en un hardware que no ha
              sido actualizado, y tu cuerpo está gritando por ayuda.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Reveal */}
      <section className="py-16 px-4 bg-gradient-to-b from-zinc-950 to-black" data-id="element-86">
        <div className="max-w-6xl mx-auto" data-id="element-87">
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-88">
            <div data-id="element-89">
              <div className="inline-block bg-cyan-500/10 border border-cyan-500 rounded-full px-6 py-2 mb-6" data-id="element-90">
                <p className="text-cyan-400 font-bold" data-id="element-91">LA REVELACIÓN</p>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-92">
                Después de analizar miles de marcadores biológicos, descubrimos
                la verdad:
              </h2>

              <div className="space-y-4 mb-8" data-id="element-93">
                <div className="flex items-start gap-3" data-id="element-94">
                  <ZapIcon className="h-6 w-6 text-cyan-400 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-95" />
                  <p className="text-gray-300" data-id="element-96">
                    Tu cuerpo{' '}
                    <strong className="text-white" data-id="element-97">no ha olvidado</strong> cómo
                    producir vitalidad; simplemente está{' '}
                    <strong className="text-cyan-400" data-id="element-98">"bloqueado"</strong> por
                    la inflamación y la resistencia a la insulina.
                  </p>
                </div>

                <div className="flex items-start gap-3" data-id="element-99">
                  <TrendingUpIcon className="h-6 w-6 text-cyan-400 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-100" />
                  <p className="text-gray-300" data-id="element-101">
                    La mayoría de los programas de fitness fallan porque están
                    hechos para jóvenes de 20 años con hormonas explosivas.
                  </p>
                </div>

                <div className="flex items-start gap-3" data-id="element-102">
                  <CheckIcon className="h-6 w-6 text-cyan-400 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-103" />
                  <p className="text-gray-300" data-id="element-104">
                    Necesitas un sistema de{' '}
                    <strong className="text-white" data-id="element-105">Precisión Metabólica</strong>{' '}
                    que trabaje <strong className="text-cyan-400" data-id="element-106">CON</strong>{' '}
                    tu biología actual, no contra ella.
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500 rounded-xl p-8 text-center" data-id="element-107">
                <p className="text-2xl md:text-3xl font-bold mb-2" data-id="element-108">
                  Presentamos:
                </p>
                <p className="text-4xl md:text-5xl font-extrabold text-gradient" data-id="element-109">
                  The Prime Architect 40+
                </p>
              </div>
            </div>

            <div className="relative" data-id="element-110">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 blur-3xl" data-id="element-111"></div>
              <img src="https://cdn.magicpatterns.com/uploads/kwkTuukb3uuekR8yZETrQr/Imagen_1_T.png" alt="The Prime Architect 40+ - Sistema completo mostrado en dispositivos digitales" className="relative z-10 w-full rounded-lg shadow-2xl" data-id="element-112" />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-113">
        <div className="max-w-6xl mx-auto" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-115">
            Resultados Reales de Hombres Reales
          </h2>
          <p className="text-xl text-gray-400 mb-12 text-center" data-id="element-116">
            Miles de hombres de 40+ ya han reclamado su vigor
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-117">
            <TestimonialCard name="Marc S." location="Austin, TX" result="Resultado: -12lbs de grasa en 30 días" quote="A los 47 años pensaba que mi 'dad bod' era permanente. Tras 4 semanas con Prime Architect, mi energía se duplicó. He bajado 12 libras de grasa abdominal y mis camisas vuelven a apretar en los brazos, no en la cintura. Mi esposa dice que parezco otro hombre." data-id="element-118" />

            <TestimonialCard name="David R." location="Chicago, IL" result="Resultado: Optimizó T-Libre de 350 a 720 ng/dL" quote="Lo mejor es la claridad mental. El 'brain fog' desapareció en la primera semana. Entreno 35 minutos y rindo más en mi empresa que cuando tenía 30. Este es el manual que todo hombre de mi edad debería recibir al cumplir los 40." data-id="element-119" />

            <TestimonialCard name="Robert L." location="Miami, FL" result="Resultado: Recuperación total de energía post-trabajo" quote="Era escéptico. Pensaba que necesitaba TRT. Este protocolo me enseñó a leer mi propia sangre y a usar la nutrición de Costco a mi favor. Mi libido regresó y mis dolores de rodilla desaparecieron. Increíble." data-id="element-120" />
          </div>

          <div className="relative rounded-xl overflow-hidden" data-id="element-121">
            <img src="https://cdn.magicpatterns.com/uploads/wng7ALzZobddcy6a4GsBR9/Concepto4.png" alt="Transformación de antes y después - De Dad Bod a Arquitecto Prime en 30 días, -12 lbs de grasa" className="w-full" data-id="element-122" />
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="py-16 px-4 bg-gradient-to-b from-zinc-950 to-black" data-id="element-123">
        <div className="max-w-4xl mx-auto" data-id="element-124">
          <div className="bg-zinc-900 border-2 border-cyan-500 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-125">
            <div className="text-center mb-8" data-id="element-126">
              <p className="text-gray-400 mb-2" data-id="element-127">
                Podríamos cobrar fácilmente $97 por este sistema...
              </p>
              <p className="text-xl text-gray-300 mb-6" data-id="element-128">
                Pero nuestra misión es ayudar a{' '}
                <strong className="text-cyan-400" data-id="element-129">10,000 hombres</strong> a
                recuperar su mando este año.
              </p>

              <div className="inline-block bg-red-600 text-white px-6 py-3 rounded-lg mb-6 animate-pulse" data-id="element-130">
                <p className="font-bold" data-id="element-131">
                  ⚡ OFERTA DE LANZAMIENTO - 93% DE DESCUENTO ⚡
                </p>
              </div>
            </div>

            <div className="text-center mb-8" data-id="element-132">
              <p className="text-gray-400 mb-2" data-id="element-133">Precio Regular:</p>
              <p className="text-4xl font-bold text-gray-500 line-through mb-4" data-id="element-134">
                $97
              </p>

              <p className="text-2xl font-bold text-cyan-400 mb-2" data-id="element-135">
                TU PRECIO HOY:
              </p>
              <p className="text-6xl md:text-7xl font-extrabold text-gradient mb-2" data-id="element-136">
                $6.39
              </p>
              <p className="text-xl text-green-400 font-bold" data-id="element-137">
                Ahorras más de $90... menos de lo que cuesta un café por semana.
              </p>
            </div>

            <div className="bg-zinc-950 border border-zinc-800 rounded-xl p-6 mb-8" data-id="element-138">
              <p className="text-center text-gray-300" data-id="element-139">
                <strong className="text-white" data-id="element-140">UN SOLO PAGO</strong> - Acceso
                inmediato y de por vida a todo el sistema
              </p>
            </div>

            <CTAButton size="large" className="w-full justify-center" onClick={handleBuyClick} data-id="element-141">
              COMPRAR AHORA - $6.39
            </CTAButton>

            <p className="text-center text-sm text-gray-500 mt-6" data-id="element-142">
              🔒 Pago seguro • Acceso instantáneo • Garantía de 60 días
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-143">
        <div className="max-w-4xl mx-auto" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-145">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-146">
            <FAQItem question="¿Realmente funciona si tengo más de 50 años?" answer="Absolutamente. El protocolo se basa en fisiología humana básica. De hecho, los hombres de 50+ suelen ver los cambios más dramáticos porque su margen de mejora hormonal es mayor." data-id="element-147" />

            <FAQItem question="¿Necesito ir a un gimnasio comercial?" answer="No. Aunque es ideal, el Bonus #3 está diseñado para que puedas obtener resultados increíbles solo con un par de mancuernas o incluso con tu propio peso corporal en casa." data-id="element-148" />

            <FAQItem question="¿Tengo que dejar de comer lo que me gusta?" answer="No es una dieta de privación. Te enseñamos a ser un 'Arquitecto de Carbohidratos'. Aprenderás cuándo comer lo que te gusta para que se convierta en músculo, no en grasa." data-id="element-149" />

            <FAQItem question="¿Es este programa solo para hombres en USA?" answer="El contenido es universal, aunque las guías de compra están optimizadas para tiendas como Costco o Whole Foods comunes en EE. UU., los principios funcionan en cualquier lugar." data-id="element-150" />

            <FAQItem question="¿Qué pasa si ya estoy en TRT?" answer="Este programa es el complemento perfecto. Optimizar tu nutrición y entrenamiento hará que tu terapia médica funcione 10 veces mejor con dosis menores." data-id="element-151" />
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-16 px-4 bg-black" data-id="element-152">
        <div className="max-w-4xl mx-auto" data-id="element-153">
          <div className="bg-gradient-to-r from-green-900/20 to-emerald-900/20 border-2 border-green-500 rounded-2xl p-8 md:p-12 text-center" data-id="element-154">
            <ShieldCheckIcon className="h-20 w-20 text-green-500 mx-auto mb-6" aria-hidden="true" data-id="element-155" />

            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-156">
              Garantía <span className="text-green-400" data-id="element-157">"IRON-MEN"</span>
            </h2>

            <p className="text-xl text-gray-300 leading-relaxed mb-6" data-id="element-158">
              Pruébalo por{' '}
              <strong className="text-white" data-id="element-159">60 días sin riesgo</strong>. Si
              después de aplicar el protocolo de 90 días no te sientes con más
              energía, no ves una reducción en tu cintura o simplemente no estás
              100% satisfecho, envíanos un email y te devolveremos cada centavo.
            </p>

            <p className="text-lg text-gray-400 mb-6" data-id="element-160">
              Sin preguntas. Te quedas con todo el material de todos modos por
              las molestias.
            </p>

            <p className="text-2xl font-bold text-green-400" data-id="element-161">
              Ese es el tamaño de nuestra confianza.
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-gradient-to-b from-zinc-950 to-black" data-id="element-162">
        <div className="max-w-4xl mx-auto" data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-164">
            Tienes Dos Caminos Frente a Ti Hoy
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-165">
            <div className="bg-zinc-900 border border-red-500/50 rounded-xl p-8" data-id="element-166">
              <h3 className="text-2xl font-bold text-red-400 mb-4" data-id="element-167">Camino A</h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-168">
                No haces nada. Sigues sintiéndote fatigado, viendo cómo la
                barriga crece año tras año y aceptando que "esto es lo que hay".
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 border-2 border-cyan-500 rounded-xl p-8" data-id="element-169">
              <h3 className="text-2xl font-bold text-cyan-400 mb-4" data-id="element-170">
                Camino B
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-171">
                Tomas el mando. Inviertes menos de lo que cuesta un tanque de
                gasolina en el sistema que reconstruirá tu presencia, tu energía
                y tu físico.
              </p>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-172">
            <p className="text-2xl font-bold text-white mb-6" data-id="element-173">
              La elección es tuya,{' '}
              <span className="text-gradient" data-id="element-174">Arquitecto</span>.
            </p>
          </div>

          <CTAButton size="large" className="w-full justify-center" onClick={scrollToCTA} data-id="element-175">
            ACCESO INMEDIATO AL PLAN
          </CTAButton>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 bg-zinc-950 border-t border-zinc-800" data-id="element-176">
        <div className="max-w-7xl mx-auto text-center text-gray-500 text-sm" data-id="element-177">
          <p data-id="element-178">© 2024 The Prime Architect 40+. Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-179">
            Este producto es solo para fines educativos e informativos.
          </p>
        </div>
      </footer>
    </div>;
}